import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { launchWickets9 } from "../services/wickets9.service";
import userDeviceStore from "../../../store/device.store";

export function Wickets9() {
  const navigate = useNavigate();
  const location = useLocation();

  const accessModeSource = userDeviceStore((state) => state.accessModeSource);

  useEffect(() => {
    let mounted = true;

    const init = async () => {
      try {
        await launchWickets9(location.pathname, accessModeSource.sourceType);
      } catch {
        if (mounted) navigate("/");
      }
    };

    init();

    return () => {
      mounted = false;
    };
  }, [location.pathname, navigate]);
  return null;
}
